/// <reference path="../../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class AddressSelectGrid extends _Ext.GridBase<ECommerce.ECommOrderAddressRow, any> {
        protected getColumnsKey() { return 'Common.AddressSelect'; } 
        protected getIdProperty() { return ECommerce.ECommOrderAddressRow.idProperty; } 
        protected getLocalTextPrefix() { return ECommerce.ECommOrderAddressRow.localTextPrefix; }
        protected getService() { return ECommerce.AddressSelectForPickUpService.baseUrl; } 
        private autoSize; 
        constructor(container: JQuery,options) {
            super(container, options);

            if (!isNaN(options.GridFilters.CustomerId))
                (this.view.params as TransactionRequest).POSCustomerId = options.GridFilters.CustomerId;

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
           
            return columns;
        };

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): ECommerce.ECommOrderAddressRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
             

            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}